import React, { PureComponent } from 'react'
import { PieChart, Pie, Legend, Tooltip, Cell } from 'recharts'
import PropTypes from 'prop-types'

// const data01 = [
//   { name: 'Project', value: 411 },
//   { name: 'Transactional', value: 357 },
//   { name: 'Non Transactional', value: 47 }
// ]

// const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042']

const RADIAN = Math.PI / 180
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5
  const x = cx + radius * Math.cos(-midAngle * RADIAN)
  const y = cy + radius * Math.sin(-midAngle * RADIAN)

  return (
    <text
      x={x}
      y={y}
      fill='white'
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline='central'
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  )
}

function PieChartCustom (props) {
  const { width, height, colors, data ,} = props

  return (
    <>
      <PieChart width={width} height={height}>
        <Pie
          data={data}
          dataKey="value"
          cx={270}
          cy={110}
          labelLine={false}
          label={renderCustomizedLabel}
          outerRadius={100}
          fill='#8884d8'
        >
          {data.map((entry, index) => (
            <Cell key={index} fill={colors[entry.name]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
        
      </PieChart>
    </>
  )
}

PieChartCustom.propTypes = {
  data: PropTypes.array.isRequired
}

export default PieChartCustom
